<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <CategoryForm :baseCategory="category" :basecategoryName="name" :loading="loading" @submit-requested="submitRequested"></CategoryForm>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import CategoryForm from './CategoryForm.vue'
    import router from '@/router';

    export default {
        data() {
            return {
                category: null,
                name: this.$route.params.name,
                loading: true
            }
        },
        components: { CategoryForm },
        computed:
        {
            ...mapState('categories', ['getCategoryByIdOutput']),
        },
        methods: {
            ...mapActions('categories', ['getCategoryById']),
            ...mapActions('categories', ['putCategory']),
            submitRequested(category) {
                this.putCategory(category);
            },
        },
        mounted: function () {
            if (!this.$route.query.id) {
                router.push({name: "Categories"});
            }
            else {
                this.getCategoryById(this.$route.query.id);
            }
        },
        watch:
        {
            getCategoryByIdOutput: function (output) {
                if (!output) {
                    router.push({name: "Categories"});
                }
                else {
                    this.category = output;
                    this.loading = false;
                }
            }
        }
    }
</script>